import ICONS_CONFIG_BY_NAME from './icons';
import useStyles from './styles';

export default function Icon({ name, className, ...props }: IconProps) {
  const classes = useStyles();
  const iconConfig: IconConfig = ICONS_CONFIG_BY_NAME[name];

  return (
    <svg
      width={iconConfig.width}
      height={iconConfig.height}
      viewBox={`0 0 ${iconConfig.width} ${iconConfig.height}`}
      className={`${classes.icon} ${className}`}
      data-testid={props['data-testid']}
    >
      {iconConfig.paths.map((path) => (
        <path
          key={path.shape.slice(0, 10)}
          d={path.shape}
          fillRule={path.fillRule}
          clipRule={path.clipRule}
        />
      ))}
    </svg>
  );
}
